import type { PendingStoreKiosk } from '@gozoki/api-types'
import { createContext } from 'react'

export interface ClientEntryContextType {
  pendingKiosks: PendingStoreKiosk[]
  askEntry: (pendingKiosk: PendingStoreKiosk) => void
  openClientForPendingKiosk: (kioskId: number, openPage: boolean) => void
}

export const ClientEntryContext = createContext<ClientEntryContextType>({
  askEntry: () => {},

  openClientForPendingKiosk: () => {},

  pendingKiosks: [],
})
